import { EXPAND_FIELD, SELECT_FIELD, CHECK_FIELD, CHECK_INDETERMINATE_FIELD } from './consts';
import { getNestedValue } from './misc';
/**
 * @hidden
 */
var FieldsService = /** @class */ (function () {
    function FieldsService(treeViewProps) {
        this.expandField = treeViewProps.expandField || EXPAND_FIELD;
        this.selectField = treeViewProps.selectField || SELECT_FIELD;
        this.hasChildrenField = treeViewProps.hasChildrenField || 'hasChildren';
        this.textField = treeViewProps.textField || 'text';
        this.disableField = treeViewProps.disableField || 'disabled';
        this.checkField = treeViewProps.checkField || CHECK_FIELD;
        this.checkIndeterminateField = treeViewProps.checkIndeterminateField || CHECK_INDETERMINATE_FIELD;
        this.focusIdField = treeViewProps.focusIdField;
    }
    FieldsService.prototype.expanded = function (item) {
        return getNestedValue(this.expandField, item);
    };
    FieldsService.prototype.selected = function (item) {
        return getNestedValue(this.selectField, item);
    };
    FieldsService.prototype.text = function (item) {
        return getNestedValue(this.textField, item);
    };
    FieldsService.prototype.disabled = function (item) {
        return getNestedValue(this.disableField, item);
    };
    FieldsService.prototype.hasChildren = function (item) {
        return getNestedValue(this.hasChildrenField, item);
    };
    FieldsService.prototype.checked = function (item) {
        return getNestedValue(this.checkField, item);
    };
    FieldsService.prototype.checkIndeterminate = function (item) {
        return getNestedValue(this.checkIndeterminateField, item);
    };
    FieldsService.prototype.focusId = function (item) {
        return this.focusIdField && getNestedValue(this.focusIdField, item);
    };
    return FieldsService;
}());
export default FieldsService;
//# sourceMappingURL=FieldsService.js.map